import { useAuthApi, useMessage } from 'app/context';
import { ContainerWrapper } from './ChangePassword.styles';
import { useForm } from 'app/hooks';
import { IChangePasswordRequest } from 'generated/axios';
import { t } from 'i18next';
import { buildErrorDetails, buildErrorMessage } from 'app/utils';
import { Box, Button, Grid, Link } from '@mui/material';
import { TextField, Typography } from 'app/shared';
import { useNavigate } from 'react-router-dom';

import { useState } from 'react';

export const ChangePassword = () => {
  const { authApi } = useAuthApi();
  const { success, error } = useMessage();
  const navigate = useNavigate();

  const [loading, setLoading] = useState<boolean>(false);

  //API
  const changePassword = (form: IChangePasswordRequest) => {
    setLoading(true);
    authApi
      .changePassword(form)
      .then((resp) => {
        if (resp.status >= 400) {
          return Promise.reject(resp);
        }
        success({ message: t('changePassword.success') as string });
        navigate(-1);
      })
      .catch((err) => {
        error({ message: buildErrorMessage(err) });
        setErrors(buildErrorDetails(err));
      })
      .finally(() => setLoading(false));
  };
  //form
  const { bindTextField, submit, setErrors } = useForm<IChangePasswordRequest>({
    onSubmit: changePassword,
  });

  return (
    <ContainerWrapper>
      <Typography detailTitle>{t('changePassword.title')}</Typography>
      <Grid container spacing={4} padding={4}>
        <Grid size={12}>
          <TextField label={t('changePassword.currentPassword')} {...bindTextField({ field: 'old_password' })} />
        </Grid>
        <Grid size={12}>
          <TextField label={t('changePassword.newPassword')} {...bindTextField({ field: 'new_password' })} />
        </Grid>
      </Grid>
      <Button loading={loading} variant="contained" onClick={submit}>
        {t('actions.submit')}
      </Button>
      <Box padding={1}>
        <Link onClick={() => navigate(-1)}>{t('actions.back')}</Link>
      </Box>
    </ContainerWrapper>
  );
};
